import styled from 'styled-components';

import { Tag } from '@xing-com/tag';
import { spaceM } from '@xing-com/tokens';

export const StyledTag = styled(Tag)`
  display: inline-flex;
  margin-bottom: ${spaceM};
  margin-right: ${spaceM};
  user-select: auto;
  &:hover {
    text-decoration: none;
  }
`;
